 <script>
export default {
  methods: {
    pageAssign: function(pageMsg) {
      let { pageSize, pageNo, totalRecords } =pageMsg;
      return {
        pageSize: pageSize,
        pageNo: pageNo,
        totalRecords: totalRecords
      };
    }
  }
};
</script>